import { useMapViewport } from "./useMapViewport/useMapViewport";
import { getMapPadding } from "./calculateMapBounds";
import { useDebounceValue } from "@hooks/useDebounce/useDebounceValue";
import { useEffect } from "react";
import { shallowObjectEquality } from "@lib/shallowObjectEquality";
import { useAppDispatch } from "@store/store";
import { setViewportAction } from "@store/map/mapReducer";

/**
 * Monitor map changes and triggers when there are new bounds. New bounds will affect the entities
 * that are visible on the map.
 */
const MapBounds = () => {
  const padding = getMapPadding(false);
  const dispatch = useAppDispatch();
  const viewport = useMapViewport({
    padding: { left: padding.left, right: padding.right },
  });

  const [debouncedViewport] = useDebounceValue(viewport, 1000, {
    equalityFn: shallowObjectEquality,
  });

  useEffect(() => {
    dispatch(setViewportAction(debouncedViewport));
  }, [debouncedViewport, dispatch]);

  return null;
};

export { MapBounds };
